// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// ------
import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// --------------------------------------------------------
// COMPONENT_NAME INTERFACE
// --------------------------------------------------------

interface IRadios {
    itens?: any[];
    selecetedValue: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const Radios = ({ itens = [],  selecetedValue}: IRadios) => {
  // --------------------------------------------------------
  // COMPONENT_NAME PRIVATE DECLARATIONS
  // --------------------------------------------------------

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        {itens.map((d, index) => (
            <FormControlLabel
            value={d.value}
            onChange={(e: any) => selecetedValue(e.target.value)}
            control={<Radio />}
            label={d.label}
            />
        ))}
      </RadioGroup>
    </FormControl>
  );
  // --------------------------------------------------------
};

export default Radios;
